import {createContext} from 'react';

const ProjectsContext = createContext(null);

export default ProjectsContext;
